import React, { useState } from "react";
interface TimeToggleProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  className?: string;
}
 
const TimeToggle: React.FC<TimeToggleProps> = ({
  value,
  onChange,
  placeholder,
  className = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = value && value.length > 0;

  return (
    <div className="relative inline-block">
      <input
        type="time"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={`rounded-lg border border-text-muted px-4 w-full py-1 text-text-muted outline-none ${className}`}
      />
      <span
        className={`pointer-events-none absolute left-4 transition-all duration-200 ${
          isFocused || hasValue
            ? "-top-2 bg-white px-1 text-xs text-primary"
            : "top-1/2 -translate-y-1/2 text-sm text-text-muted"
        } `}
      >
        {isFocused || hasValue ? placeholder : placeholder}
      </span>
    </div>
  );
};

export default TimeToggle;
